import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../utils/api";

function* updateRewards(action) {
  const action_1 = Object.assign({});
  const { payload } = action || {};
  const { isHistory } = payload || false;
  action_1.handler = "V3_GET_REWARDS";
  // action_1.query = { config_id: 75919 }; //this is for slider
  // action_1.query = {config_id: 75966}; //this is for non slider
  // action_1.query = {config_id: 75943};//this is for bumber
  // action_1.query = {config_id: 208602}; //this is for scaled
  // action_1.query = {config_id: 75970}; //this is for new design
  // action_1.query = { config_id: 209223 };
  if (isHistory && payload.room_id) {
    action_1.query = { room_id: payload.room_id };
    action_1.handler = "V3_GET_HISTORYREWARDS";
  }
  if (payload.config_id) {
    action_1.query = { config_id: payload.config_id };
  } else if (payload.room_id) {
    action_1.query = { room_id: payload.room_id };
  }
  if (action_1.query) {
    const response = yield call(api, action_1);
    if (response.status === 200) {
      yield put({ type: "UPDATE_CONTEST_PRIZES", rewards: response.data });
    }
  }
}
function* getRewards() {
  yield takeLatest("GET_REWARDS", updateRewards);
}

//------------------------------------------------------------------------------------------------------

export default [getRewards];



// WEBPACK FOOTER //
// ./src/shells/Rewards/sagas.js